import React, { Fragment } from 'react';
import { Dialog, FormControl, MenuItem, RadioGroup, Radio, Stack, Grid, Popover, Typography, Box, FormLabel, Paper, OutlinedInput } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import contractStyles from './contracts.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, InputProps, CustomSelect, CustomRadio, CustomDialogContent, SelectInputProps, CustomFormHelperText } from '../../../../../custom/components';
import { CloseIconBtn, appliedOnItems, roles, platforms, driversOptions, structureOptions } from 'custom/constants';
import { InfoOutlined } from '@mui/icons-material';

const AddNonCommercialItem = (props) => {

  const { action } = props;
  const LABEL_PROPS = {
    direction: {
      xs: 'column',
      sm: 'row' 
    },
    alignItems: {
      xs: 'flex-start',
      sm: 'center' 
    }
  };

  // const NUMBERINPUT_PROPS = {
  //   '&[type=number]': { '-moz-appearance': 'textfield', },
  //   '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none', },
  //   '& input[type=number]': { MozAppearance: 'textfield', },
  // };

  const LABELSTYLE = {
    color: 'primary.main',
    fontWeight: 'bold',
    borderBottom: '1px solid #b6b6b6',
    paddingBottom: 1,
    marginBottom: 1,
    fontSize: 14,
  };

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'commercial_item'} onClose={props.onClose} maxWidth={'lg'} fullWidth scroll='paper'>
        <CustomDialogTitle id='form-dialog-title'>
          {action == 'add' ? 'Add' : 'Edit'} Statistics Line Item
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <StyledCard>
            <Grid container spacing={{
              xs: 1,
              sm: 3,
            }} columnSpacing={8}>
              <Grid item xs={12} sm={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='description' required className={contractStyles.labelInline}>Item Description</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='description'
                    placeholder='Description'
                    type='text'
                    name='description'
                    value={props.controwField.description}
                    onChange={props.onChangecontrowField}
                    error={props.controwErrors.description}
                    helperText={props.controwErrors.description}
                  />
                </Stack>
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='is_noncommercial' aria-label='Is Combination' className={contractStyles.labelInline}>Combination Of</CustomInputLabel>
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'non-commercial', }}  checked={props.controwField.is_noncommercial} onChange={props.onChangecontrowField} name='is_noncommercial' size='small' />
                    }
                    label=''
                    classes={{ root: styles.mr2 }}
                  /> */}
              {/* <FormControl variant='standard' fullWidth error={props.controwErrors.record_on}>
                    <CustomSelect
                      multiple
                      {...SelectInputProps}
                      id='commercial_items'
                      labelId='commercial_items_label'
                      fullWidth
                      name='commercial_items'
                      value={props.controwField.commercial_items || []}
                      onChange={props.onChangecontrowField}
                      classes={{ select: !props.controwField.commercial_items ? styles.colorPlaceholder : '' }}
                      disabled={props.controwField.is_noncommercial ? false : true}
                    >
                      <MenuItem value='placeholder' disabled>Select Non Commercial Items</MenuItem>
                      {props.commercial_options.map((row, i) => (
                        <MenuItem key={i} value={row.id}>
                          {row.description}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                    <CustomFormHelperText>{props.controwErrors.commercial_items}</CustomFormHelperText>
                  </FormControl> */}
              {/* <FormControl variant='standard' fullWidth error={props.controwErrors.record_on}>
                    <CustomAutocomplete
                      multiple
                      id='commercial_items'
                      options={props.commercial_options}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.description}
                      value={props.nonCommOpts || []}
                      onChange={(event, value) => props.handleCustomMultiSelect(value)}
                      isOptionEqualToValue={(option, value) => option.id === value.id} 
                      classes={{ option: styles.autocompleteCheckboxOption }}
                      disabled={props.controwField.is_noncommercial ? false : true}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlank fontSize='small' />}
                              checkedIcon={<CheckBox fontSize='small' />}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.description}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <CustomTextField {...params} label='' error={props.controwErrors.commercial_items} placeholder={props.nonCommOpts.length > 0 ? '' : 'Combination Items'} />
                      )}
                    />
                    <CustomFormHelperText>{props.controwErrors.commercial_items}</CustomFormHelperText>
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='noncommercial_page' aria-label='Non Commercial' className={contractStyles.labelInline}>Non Commercial Page</CustomInputLabel>
                  <FormControl variant='standard' fullWidth error={props.controwErrors.record_on}>
                    <CustomSelect
                      multiple
                      {...SelectInputProps}
                      id='sheetlist'
                      labelId='sheetlist_label'
                      fullWidth
                      name='sheetlist'
                      value={props.controwField.sheetlist || []}
                      onChange={props.onChangecontrowField}
                      classes={{ select: !props.controwField.sheetlist ? styles.colorPlaceholder : '' }}
                      disabled={props.controwField.is_noncommercial ? false : true}
                    >
                      <MenuItem value='placeholder' disabled>Select Non Commercial Page</MenuItem>
                      <MenuItem key={1} value={'Flight Details'}>{'Flight Details'}</MenuItem>
                      <MenuItem key={2} value={'Flight Summary'}>{'Flight Summary'}</MenuItem>
                    </CustomSelect>
                    <CustomFormHelperText>{props.controwErrors.sheetlist}</CustomFormHelperText>
                  </FormControl>
                </Stack>
              </Grid> */}
              {
                !props.controwField.is_noncommercial ?
                  <>
                    <Grid item xs={12} md={12}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel htmlFor='applied_on' required className={contractStyles.labelInline} sx={{ mb: 'auto' }}>Applied On</CustomInputLabel>
                        <Grid container spacing={3}>
                          <Grid item xs={12}>
                            <Paper elevation={0} sx={{
                              p: 1.8,
                              bgcolor: '#f7f7f7' 
                            }}>
                              <FormControl fullWidth component='fieldset'>
                                <FormLabel sx={LABELSTYLE}>Drivers</FormLabel>
                                <RadioGroup
                                  aria-labelledby='drivers'
                                  name='drivers'
                                  row
                                  id='drivers'
                                  // defaultValue={'KGS'}
                                  onChange = {props.handleRadioChange}
                                  value={props.appliedOn.drivers}
                                  // error={props.appliedOn.drivers}
                                >
                                  <Grid container spacing={1} alignItems='center' flexWrap='wrap' justifyContent='space-between'>
                                    {driversOptions.map(opt => (
                                      opt.statisticsDriver && (
                                        <Grid item xs={'auto'} key={opt.value}>
                                          <CustomRadio
                                            control={<Radio size='small' />}
                                            value={opt.value}
                                            label={opt.label}
                                          />
                                        </Grid>
                                      )
                                    ))}
                                  </Grid>
                                </RadioGroup>
                              </FormControl>
                            </Paper>
                          </Grid>

                          <Grid item xs={12} container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <Paper elevation={0} sx={{
                                p: 2,
                                minHeight: '100px',
                                bgcolor: '#f7f7f7'
                              }} className={styles.h100}>
                                <FormControl component='fieldset' fullWidth>
                                  <FormLabel sx={LABELSTYLE}>Structure</FormLabel>
                                  <Grid container spacing={7} alignItems='center'>
                                    <Grid item xs={6}>
                                      <RadioGroup
                                        aria-labelledby='structure'
                                        name='structure'
                                        onChange={props.handleRadioChange}
                                        row
                                        defaultValue={'total'}
                                        value={props.appliedOn.structure}
                                        disabled={props.appliedOn.drivers === 'units'}
                                      >
                                        <Stack direction='row' spacing={2} flexWrap='wrap' justifyContent='space-between' flex={1}>
                                          {props.appliedOn?.structureType ? Array.isArray(structureOptions[props.appliedOn.structureType]) && structureOptions[props.appliedOn.structureType].length > 0 &&
                                                structureOptions[props.appliedOn.structureType].map(option => (
                                                  <CustomRadio
                                                    key={option.value}
                                                    control={<Radio size='small' />}
                                                    value={option.value}
                                                    label={option.label}
                                                    disabled={props.appliedOn.drivers === 'units' && option.value.toLowerCase() === 'total'}
                                                  />
                                                )) : <></>
                                          }
                                        </Stack>
                                      </RadioGroup>
                                    </Grid>
                                    <Grid item xs minWidth={'120px'}>
                                      {props.appliedOn.structure === 'Intact' &&
                                            <FormControl variant='outlined' fullWidth className={`${styles.borderedIpTextfield}`}>
                                              <CustomSelect
                                                {...SelectInputProps}
                                                id='type'
                                                labelId='type-label'
                                                fullWidth
                                                name='type'
                                                value={!props.appliedOn.type ? 'placeholder' : props.appliedOn.type}
                                                disabled={props.appliedOn.structure !== 'Intact'}
                                                onChange={props.handleRadioChange}
                                                classes={{ 
                                                  select: !props.controwField.productId ? styles.colorPlaceholder : '',
                                                  root: styles.borderedIpRoot,
                                                  input: styles.borderedIp,
                                                }}
                                                input={<OutlinedInput 
                                                  classes={{
                                                    notchedOutline: styles.notchedOutline,
                                                    error: styles.errorInput,
                                                  }} 
                                                />}
                                              >
                                                <MenuItem value='placeholder' disabled >Select Type</MenuItem>
                                                {/* {['KGs', 'MD', 'LD3', 'LD7'].map((type, i) => ( */}
                                                <MenuItem key={'All'} value={'Total'}>{'All'}</MenuItem>
                                                <MenuItem key={'KGs'} value={'KGs'}>{'KGs'}</MenuItem>
                                                <MenuItem key={'MD'} value={'MD'}>{'MD'}</MenuItem>
                                                <MenuItem key={'LD3'} value={'LD3'}>{'LD3'}</MenuItem>
                                                <MenuItem key={'LD7'} value={'LD7'}>{'LD7'}</MenuItem>
                                                {/* ))} */}
                                              </CustomSelect>
                                            </FormControl>
                                      }
                                    </Grid>
                                  </Grid>
                                </FormControl>
                              </Paper>
                            </Grid>

                            {/* Product Specific */}
                            <Grid item xs={12} md={6} lg={6}>
                              <Paper elevation={0} sx={{
                                p: 2,
                                minHeight: '100px',
                                bgcolor: '#f7f7f7'
                              }} className={styles.h100}>
                                <FormControl component='fieldset' fullWidth>
                                  <FormLabel sx={LABELSTYLE}>Product Specific</FormLabel>
                                  {
                                    (props.appliedOn.drivers === 'KGs' || props.appliedOn.drivers === 'Air Waybill' || props.appliedOn.drivers === '(Pcs)') && 
                                        <Grid container spacing={2} alignItems='center'>
                                          <Grid item xs>
                                            <RadioGroup
                                              aria-labelledby='productSpecific'
                                              name='productSpecific'
                                              onChange={props.handleRadioChange}
                                              value={props.appliedOn.productSpecific}
                                              row
                                              defaultValue={'no'}
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between' 
                                              }}
                                            >
                                              <CustomRadio control={<Radio size='small' />} value='' label='None' 
                                                // disabled={props.appliedOn.drivers === 'uld' || props.appliedOn.drivers === 'units'}
                                              />
                                              <CustomRadio control={<Radio size='small' />} value='Gen' label='Gen' 
                                                disabled={props.appliedOn.drivers === 'uld' || props.appliedOn.drivers === 'units'}
                                              />
                                              <CustomRadio control={<Radio size='small' />} value='SPL' label='SPL' 
                                                disabled={props.appliedOn.drivers === 'uld' || props.appliedOn.drivers === 'units'}
                                              />
                                            </RadioGroup>
                                          </Grid>
                                          <Grid item xs='auto' width={'150px'}>
                                            <FormControl variant='outlined' fullWidth className={`${styles.borderedIpTextfield}`}>
                                              <CustomSelect
                                                {...SelectInputProps}
                                                id='productId'
                                                labelId='product-label'
                                                fullWidth
                                                name='productId'
                                                value={!props.controwField.productId ? 'placeholder' : props.controwField.productId}
                                                disabled={props.appliedOn.productSpecific !== 'SPL' || 
                                                (!props?.controwField?.applied_on?.includes('SPL') && !props?.controwField?.applied_on?.includes('Air Waybill') )}
                                                onChange={props.onChangecontrowField}
                                                classes={{ 
                                                  select: !props.controwField.productId ? styles.colorPlaceholder : '',
                                                  root: styles.borderedIpRoot,
                                                  input: styles.borderedIp,
                                                }}
                                                input={<OutlinedInput 
                                                  classes={{
                                                    notchedOutline: styles.notchedOutline,
                                                    error: styles.errorInput,
                                                  }} 
                                                />}
                                              >
                                                <MenuItem value='placeholder' disabled >Select Product</MenuItem>
                                                {props.products.map((product, i) => (
                                                  <MenuItem key={i} value={product.id}>
                                                    {product.name}
                                                  </MenuItem>
                                                ))}
                                              </CustomSelect>
                                            </FormControl>
                                          </Grid>
                                        </Grid>
                                  }
                                </FormControl>
                              </Paper>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Stack>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel id='applied_on_label' required className={contractStyles.labelInline}>Applied On</CustomInputLabel>
                        {props.controwField.applied_on ? 
                          <CustomRadio control={<Radio size='small' defaultChecked />} value='progressive' label={props.controwField.applied_on} sx={{ mr: 1 }} />
                          : <div>-</div> }
                        <InfoOutlined color='inherit' fontSize='small' sx={{
                          opacity: 0.4,
                          marginTop: '6px',
                          marginBottom: 'auto'
                        }} onClick={(e) => props.handlePopover(true, e.target, null, null)} className={`${styles.ml2} ${styles.pointer}`} />
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel id='role_label' className={contractStyles.labelInlineRhs}>To be entered by (Employee Group)</CustomInputLabel>
                        <FormControl variant='standard' fullWidth error={props.controwErrors.roles}>
                          <CustomSelect
                            {...SelectInputProps}
                            id='role'
                            labelId='role_label'
                            fullWidth
                            name='roles'
                            disabled={!props.controwField.applied_on ? true : props.controwField?.applied_on?.includes('Auto') ? true: false}
                            value={!props.controwField.roles? ['N/A'] : props.controwField.roles[0] || props.controwField.roles}
                            onChange={props.onChangecontrowField}
                            classes={{ select: !props.controwField.roles ? styles.colorPlaceholder : '' }}
                          >
                            <MenuItem value='placeholder' disabled>Select Role</MenuItem>
                            <MenuItem value={'N/A'}>N/A</MenuItem>
                            { roles.map((role) => (
                              <MenuItem key={role.id} value={role.value}>
                                {role.value}
                              </MenuItem>
                            ))}
                          </CustomSelect>
                          <CustomFormHelperText>{props.controwErrors.role}</CustomFormHelperText>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack {...LABEL_PROPS} sx={{ marginRight: '28px', }}>
                        <CustomInputLabel id='record_on_label' required className={contractStyles.labelInline}>Record On</CustomInputLabel>
                        <FormControl variant='standard' fullWidth error={props.controwErrors.record_on}>
                          <CustomSelect
                            {...SelectInputProps}
                            id='record_on'
                            labelId='record_on_label'
                            fullWidth
                            name='record_on'
                            value={!props.controwField.record_on ? 'placeholder' : props.controwField.record_on}
                            onChange={props.onChangecontrowField}
                            classes={{ select: !props.controwField.record_on ? styles.colorPlaceholder : '' }}
                            disabled={props.controwField.link_contract ? true : props.controwField.applied_on ? false : true}
                          >
                            <MenuItem value='placeholder' disabled>Select Record On</MenuItem>
                            {
                              props.recordOns.map((record) => (
                                <MenuItem key={record} value={record}>
                                  {record}
                                </MenuItem>
                              ))
                            }
                          </CustomSelect>
                          <CustomFormHelperText>{props.controwErrors.record_on}</CustomFormHelperText>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel htmlFor='platform' aria-label='Platform' className={contractStyles.labelInlineRhs}>Platform</CustomInputLabel>
                        <>
                          <CustomSelect
                            {...SelectInputProps}
                            id='platform'
                            labelId='platform-label'
                            onChange={props.onChangecontrowField}
                            name='platform'
                            value={!props.controwField.platform ? 'N/A' : props.controwField.platform}
                            classes={{ select: !props.controwField.platform ? styles.colorPlaceholder : '' }}
                            fullWidth
                            disabled={ props.controwField.link_contract ? true : !props.controwField.record_on ? true : props.controwField.record_on === 'Month Log' || props.controwField.record_on ===  'Day Log' ? true : false }
                          >
                            <MenuItem value='placeholder'>Select a Platform</MenuItem>
                            <MenuItem value={'N/A'}>N/A</MenuItem>
                            {platforms.map((name) => (
                              <MenuItem key={name} value={name}>{name}</MenuItem>
                            ))}
                          </CustomSelect>
                        </>
                      </Stack>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <Stack {...LABEL_PROPS}>
                        <CustomInputLabel id='segment_label' className={contractStyles.labelInline}>Segment</CustomInputLabel>
                        <FormControl variant='standard' fullWidth error={props.controwErrors.segment}>
                          <CustomSelect
                            {...SelectInputProps}
                            id='segment'
                            labelId='segment_label'
                            fullWidth
                            name='segment'
                            value={!props.controwField.segment ? 'N/A' : props.controwField.segment}
                            onChange={props.onChangecontrowField}
                            classes={{ select: !props.controwField.segment ? styles.colorPlaceholder : '' }}
                            disabled={props.controwField.link_contract? true : props.controwField.applied_on ? false : true}
                          >
                            <MenuItem value='placeholder' disabled>Select Segment</MenuItem>
                            {/* <MenuItem value={'Import'}>Import</MenuItem>
                                <MenuItem value={'Export'}>Export</MenuItem>
                                <MenuItem value={'Transit'}>Transit</MenuItem> */}
                            {
                              props.segments.map((segment) => (
                                <MenuItem key={segment} value={segment}>
                                  {segment}
                                </MenuItem>
                              ))
                            }
                            <MenuItem value={'N/A'}>N/A</MenuItem>
                          </CustomSelect>
                          <CustomFormHelperText>{props.controwErrors.segment}</CustomFormHelperText>
                        </FormControl>
                      </Stack>
                    </Grid>
                  </>
                  : null
              }
              <Grid item xs={12} sm={12}>
                <Stack {...LABEL_PROPS}>
                  <CustomInputLabel htmlFor='remarks' className={contractStyles.labelInline}>Remarks</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    id='remarks'
                    placeholder=''
                    type='text'
                    name='remarks'
                    value={props.controwField.remarks}
                    onChange={props.onChangecontrowField}
                  />
                </Stack>
              </Grid>
            </Grid>
          </StyledCard>

        </CustomDialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw} ${styles.pt1}`}>
          <CustomButton variant='contained' type='reset' onClick={props.onClose}> Close </CustomButton> 
          <CustomButton variant='contained' type='submit' onClick={action == 'add' ? props?.addControw : props.editControw}> 
            {action == 'add' ? 'Submit' : 'Update'} 
          </CustomButton> 
        </CustomDialogAction>
      </Dialog>

      <Popover
        open={props.attachment}
        anchorEl={props.anchorEl}
        onClose={() => props.handlePopover(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Box className={contractStyles.popoverWrapper}>
          {appliedOnItems.map((item, i) => 
            <div key={i} className={`${styles.dFlex} ${contractStyles.desc}`}>
              <Typography variant='caption' component={'p'} marginBottom={0} whiteSpace={'nowrap'} className={`${styles.minWidth170}`}>
                {`${item.label}`}
              </Typography>
              <Typography variant='caption' component={'p'} marginBottom={0}>
                {`${item.desc}`}
              </Typography>
            </div>
          )}
        </Box>
      </Popover>
    </div>
  );
};
export default AddNonCommercialItem;